export default import.meta.ROLLDOWN_FILE_URL_V1ZYpwZc9C51fJhgOTS5xQ